import { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { ArrowRight, Clock } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function BlogFeed({ limit = 3 }) {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    axios
      .get(`${API}/blog`)
      .then((r) => !cancelled && setPosts(r.data || []))
      .catch(() => {})
      .finally(() => !cancelled && setLoading(false));
    return () => {
      cancelled = true;
    };
  }, []);

  const items = posts.slice(0, limit);

  return (
    <section data-testid="blog-feed" className="bg-stone-50 py-20 md:py-28 border-t border-stone-200">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-12">
          <div>
            <div className="text-xs uppercase tracking-[0.22em] font-bold text-red-600">
              From the blog
            </div>
            <h2 className="mt-3 font-display text-4xl sm:text-5xl font-black tracking-tighter text-stone-900 leading-[1.02]">
              Real answers for<br />Austin property owners.
            </h2>
          </div>
          <Link
            to="/blog"
            className="inline-flex items-center gap-2 text-sm font-bold text-stone-900 hover:text-red-600 border-b-2 border-stone-900 hover:border-red-600 pb-1 self-start"
            data-testid="blog-feed-all-link"
          >
            See all articles <ArrowRight size={14} />
          </Link>
        </div>

        {loading ? (
          <div className="grid md:grid-cols-3 gap-5">
            {[1, 2, 3].map((i) => (
              <div key={i} className="aspect-[4/5] bg-stone-200 animate-pulse" />
            ))}
          </div>
        ) : (
          <div className="grid md:grid-cols-3 gap-5">
            {items.map((p) => (
              <article
                key={p.id}
                className="group bg-white border border-stone-200 hover:shadow-xl transition-shadow"
                data-testid={`blog-card-${p.slug}`}
              >
                <Link to={`/blog/${p.slug}`} className="block">
                  <div className="aspect-[16/10] overflow-hidden border-b border-stone-200">
                    <img
                      src={p.cover_image}
                      alt={p.title}
                      className="w-full h-full object-cover group-hover:scale-[1.04] transition-transform duration-700"
                      loading="lazy"
                    />
                  </div>
                  <div className="p-7">
                    <div className="flex items-center justify-between text-[10px] uppercase tracking-[0.22em] font-bold">
                      <span className="text-red-600">{p.category}</span>
                      <span className="text-stone-500 flex items-center gap-1.5">
                        <Clock size={12} /> {p.read_time}
                      </span>
                    </div>
                    <h3 className="mt-3 font-display text-xl font-bold text-stone-900 leading-snug tracking-tight group-hover:text-red-600 transition-colors">
                      {p.title}
                    </h3>
                    <p className="mt-3 text-sm text-stone-600 leading-relaxed line-clamp-3">
                      {p.excerpt}
                    </p>
                    <div className="mt-5 inline-flex items-center gap-2 text-xs font-bold text-stone-900">
                      Read article <ArrowRight size={14} />
                    </div>
                  </div>
                </Link>
              </article>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
